"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const FeeUtil_1 = __importDefault(require("./FeeUtil"));
const IFee_1 = require("../interfaces/IFee");
const PaymentMethodTypeEnum_1 = require("../enums/PaymentMethodTypeEnum");
const IEventPromotion_1 = require("../interfaces/IEventPromotion");
class PaymentUtil {
    calculatePaymentTotal(params) {
        var _a, _b;
        let { tickets = [], upgrades = [], fees = [], paymentMethodType, promotions = [], } = params;
        // No items, total is always 0
        if (!tickets.length && !upgrades.length)
            return 0;
        const ticketFeesPromoCodePercent = promotions === null || promotions === void 0 ? void 0 : promotions.filter((f) => f.appliesTo === IEventPromotion_1.EventPromotionAppliesToEnum.PerTicket &&
            f.discountType === IEventPromotion_1.EventPromotionDiscountTypeEnum.Percent);
        const discountFeePercentPerTicketTotal = tickets === null || tickets === void 0 ? void 0 : tickets.reduce((cur, ticket) => {
            return (cur +
                (ticketFeesPromoCodePercent === null || ticketFeesPromoCodePercent === void 0 ? void 0 : ticketFeesPromoCodePercent.reduce((cur, promotion) => {
                    const value = cur + applyTicketDiscount(ticket, promotion);
                    return value;
                }, 0)));
        }, 0);
        if (promotions === null || promotions === void 0 ? void 0 : promotions.length) {
            tickets = tickets.map(ticket => {
                var _a, _b, _c, _d;
                if (promotions && promotions[0].discountType === IEventPromotion_1.EventPromotionDiscountTypeEnum.Flat && promotions[0].appliesTo === IEventPromotion_1.EventPromotionAppliesToEnum.PerTicket) {
                    if (((_a = promotions[0]) === null || _a === void 0 ? void 0 : _a.ticketTypeIds.length) == 0) {
                        const discountValue = Number(promotions[0].discountValue);
                        const originalPrice = ticket.price;
                        const discountedPrice = originalPrice - discountValue;
                        return Object.assign(Object.assign({}, ticket), { price: discountedPrice });
                    }
                    else {
                        if ((_b = promotions[0]) === null || _b === void 0 ? void 0 : _b.ticketTypeIds.includes(ticket === null || ticket === void 0 ? void 0 : ticket.ticketTypeId)) {
                            const discountValue = Number(promotions[0].discountValue);
                            const originalPrice = ticket.price;
                            const discountedPrice = originalPrice - discountValue;
                            return Object.assign(Object.assign({}, ticket), { price: discountedPrice });
                        }
                        else {
                            const originalPrice = ticket.price;
                            return Object.assign(Object.assign({}, ticket), { price: originalPrice });
                        }
                    }
                }
                if (promotions && promotions[0].discountType === IEventPromotion_1.EventPromotionDiscountTypeEnum.Percent && promotions[0].appliesTo === IEventPromotion_1.EventPromotionAppliesToEnum.PerTicket) {
                    if (((_c = promotions[0]) === null || _c === void 0 ? void 0 : _c.ticketTypeIds.length) == 0) {
                        const discountValue = Number(promotions[0].discountValue);
                        const percentTicketValue = (ticket.origionalPrice * discountValue) / 100;
                        const originalPrice = ticket.price;
                        const discountPercentPrice = originalPrice - percentTicketValue;
                        return Object.assign(Object.assign({}, ticket), { price: discountPercentPrice });
                    }
                    else {
                        if ((_d = promotions[0]) === null || _d === void 0 ? void 0 : _d.ticketTypeIds.includes(ticket === null || ticket === void 0 ? void 0 : ticket.ticketTypeId)) {
                            const discountValue = Number(promotions[0].discountValue);
                            const percentTicketValue = (ticket.origionalPrice * discountValue) / 100;
                            const originalPrice = ticket.price;
                            const discountPercentPrice = originalPrice - percentTicketValue;
                            return Object.assign(Object.assign({}, ticket), { price: discountPercentPrice });
                        }
                        else {
                            const originalPrice = ticket.price;
                            return Object.assign(Object.assign({}, ticket), { price: originalPrice });
                        }
                    }
                }
                return ticket;
            });
        }
        // Filter fees
        fees = fees.filter((fee) => {
            var _a, _b;
            if (!(fee === null || fee === void 0 ? void 0 : fee.paymentMethods) || ((_a = fee === null || fee === void 0 ? void 0 : fee.paymentMethods) === null || _a === void 0 ? void 0 : _a.length) == 0) {
                return true;
            }
            else if ((_b = fee === null || fee === void 0 ? void 0 : fee.paymentMethods) === null || _b === void 0 ? void 0 : _b.includes(paymentMethodType)) {
                return true;
            }
            else {
                return false;
            }
        });
        let guestFees = fees.filter((fee) => fee.filters && fee.filters[0] == IFee_1.FeeFiltersEnum.GuestTicket);
        fees = fees.filter((fee) => fee.filters && fee.filters[0] !== IFee_1.FeeFiltersEnum.GuestTicket);
        function applyGuestTicketFee(ticket, fee) {
            // Ignore seated fees if not seated
            if (fee.filters &&
                fee.filters.includes(IFee_1.FeeFiltersEnum.Seated) &&
                !ticket.seat) {
                return 0;
            }
            if (!ticket.guestTicket) {
                return 0;
            }
            const minFee = fee.minAppliedToPrice || 0;
            const maxFee = fee.maxAppliedToPrice || Infinity;
            if (minFee <= ticket.price && ticket.price <= maxFee) {
                if (fee.type === IFee_1.FeeTypeEnum.Flat) {
                    return fee.value;
                }
                if (fee.type === IFee_1.FeeTypeEnum.Percent) {
                    return (ticket.price * fee.value) / 100;
                }
            }
            else {
                return 0;
            }
            return 0;
        }
        const ticketFeesPromoCodeFlat = promotions === null || promotions === void 0 ? void 0 : promotions.filter((f) => f.appliesTo === IEventPromotion_1.EventPromotionAppliesToEnum.PerTicket &&
            f.discountType === IEventPromotion_1.EventPromotionDiscountTypeEnum.Flat);
        // Fees applied
        const ticketFeesPromotersFlat = fees.filter((f) => f.appliedTo === IFee_1.FeeAppliedToEnum.Ticket &&
            f.appliedBy == IFee_1.FeeAppliedByEnum.Organization &&
            f.type === IFee_1.FeeTypeEnum.Flat);
        const ticketFeesPromotersPercent = fees.filter((f) => f.appliedTo === IFee_1.FeeAppliedToEnum.Ticket &&
            f.appliedBy == IFee_1.FeeAppliedByEnum.Organization &&
            f.type === IFee_1.FeeTypeEnum.Percent);
        const ticketFeesSelloutPercent = fees.filter((f) => f.appliedTo === IFee_1.FeeAppliedToEnum.Ticket &&
            f.appliedBy == IFee_1.FeeAppliedByEnum.Sellout &&
            f.type === IFee_1.FeeTypeEnum.Percent);
        // added upgrade fee percentage for sellout fees total
        const upgradeFeesSelloutPercent = fees.filter((f) => f.appliedTo === IFee_1.FeeAppliedToEnum.Upgrade &&
            f.appliedBy == IFee_1.FeeAppliedByEnum.Sellout &&
            f.type === IFee_1.FeeTypeEnum.Percent);
        const upgradeFeesPromotersFees = fees.filter((f) => f.appliedTo === IFee_1.FeeAppliedToEnum.Upgrade &&
            f.appliedBy == IFee_1.FeeAppliedByEnum.Organization);
        const upgradeFeesSelloutFees = fees.filter((f) => f.appliedTo === IFee_1.FeeAppliedToEnum.Upgrade &&
            f.appliedBy == IFee_1.FeeAppliedByEnum.Sellout);
        const selloutFees = fees.filter((f) => f.appliedBy == IFee_1.FeeAppliedByEnum.Sellout);
        // sales tax fee
        const salesTaxFees = fees.find((f) => f.name == "Sales tax");
        const stripeFees = fees.filter((f) => f.appliedBy == IFee_1.FeeAppliedByEnum.Stripe);
        // Orders mattes here. Flat type fees must be applied before Percent type fees
        const promoterOrderFees = fees
            .filter((f) => f.appliedTo === IFee_1.FeeAppliedToEnum.Order &&
            f.name != "Sales tax" &&
            f.appliedBy == IFee_1.FeeAppliedByEnum.Organization)
            .sort(({ type }) => {
            if (type === "Flat")
                return -1;
            else
                return 1;
        });
        // Caclualtions
        const ticketTotal = tickets.reduce((cur, ticket) => cur + ticket.price, 0);
        const upgradeTotal = upgrades.reduce((cur, upgrade) => cur + upgrade.price, 0);
        const totalTicketUpgrade = ticketTotal + upgradeTotal;
        const discountFeeFlatPerTicketTotal = tickets === null || tickets === void 0 ? void 0 : tickets.reduce((cur, ticket) => {
            return (cur +
                (ticketFeesPromoCodeFlat === null || ticketFeesPromoCodeFlat === void 0 ? void 0 : ticketFeesPromoCodeFlat.reduce((cur, promotion) => {
                    const value = cur + applyTicketDiscount(ticket, promotion);
                    return value;
                }, 0)));
        }, 0);
        const discountFeeFlatPerOrderAmt = promotions === null || promotions === void 0 ? void 0 : promotions.reduce((cur, promotion) => {
            if (promotion.discountType == IEventPromotion_1.EventPromotionDiscountTypeEnum.Flat &&
                promotion.appliesTo === IEventPromotion_1.EventPromotionAppliesToEnum.PerOrder) {
                const value = cur + promotion.discountValue;
                return value;
            }
            return cur;
        }, 0);
        const discountFeePercentPerOrderAmt = promotions === null || promotions === void 0 ? void 0 : promotions.reduce((cur, promotion) => {
            if (promotion.discountType == IEventPromotion_1.EventPromotionDiscountTypeEnum.Percent &&
                promotion.appliesTo === IEventPromotion_1.EventPromotionAppliesToEnum.PerOrder) {
                const value = cur + (totalTicketUpgrade * promotion.discountValue) / 100;
                return value;
            }
            return cur;
        }, 0);
        const discount = Math.round(discountFeeFlatPerTicketTotal || 0 + discountFeePercentPerTicketTotal || 0) || 0;
        const discountOrder = Math.round(discountFeeFlatPerOrderAmt || 0 + discountFeePercentPerOrderAmt || 0) || 0;
        const totalTicketAndUpgrades = Math.round(ticketTotal - discountOrder || 0) + Math.round(upgradeTotal);
        const promoterFeeFlatPerOrderTotal = promoterOrderFees.reduce((acc, fee) => {
            return fee.type == IFee_1.FeeTypeEnum.Flat ? acc + getFeeAmtRangeBased(fee) : acc;
        }, 0);
        const promoterFeeFlatPerTicketTotal = tickets.reduce((cur, ticket) => {
            return (cur +
                ticketFeesPromotersFlat.reduce((cur, fee) => {
                    const value = cur + applyTicketFee(ticket, fee);
                    return value;
                }, 0));
        }, 0);
        const promoterFeeFlatPerUpgradeTotal = upgrades.reduce((cur, upgrade) => {
            return (cur +
                upgradeFeesPromotersFees.reduce((cur, fee) => {
                    const value = cur + applyUpgradeFee(upgrade, fee);
                    return value;
                }, 0));
        }, 0);
        const SelloutFeeFlatPerUpgradeTotal = upgrades.reduce((cur, upgrade) => {
            return (cur +
                upgradeFeesSelloutFees.reduce((cur, fee) => {
                    const value = cur + applyUpgradeFee(upgrade, fee);
                    return value;
                }, 0));
        }, 0);
        const promoterFeePercentPerTicketTotal = tickets.reduce((cur, ticket) => {
            return (cur +
                ticketFeesPromotersPercent.reduce((cur, fee) => {
                    const value = cur + applyTicketFee(ticket, fee);
                    return value;
                }, 0));
        }, 0);
        let promoterFeePercentPerTicketTotal1 = Math.round(promoterFeePercentPerTicketTotal);
        let selloutFeePercentPerTicketTotal = tickets.reduce((cur, ticket) => {
            return (cur +
                ticketFeesSelloutPercent.reduce((cur, fee) => {
                    const value = cur + applyTicketFee(ticket, fee);
                    return value;
                }, 0));
        }, 0);
        // added upgrade fee percentage for sellout fees total
        let selloutFeePercentPerUpgradeTotal = upgrades.reduce((cur, upgrade) => {
            return (cur +
                upgradeFeesSelloutPercent.reduce((cur, fee) => {
                    const value = cur + applyUpgradeFee(upgrade, fee);
                    return value;
                }, 0));
        }, 0);
        selloutFeePercentPerTicketTotal = Math.round(selloutFeePercentPerTicketTotal);
        const promoterFeePercentPerOrder = promoterOrderFees.reduce((acc, fee) => {
            if (fee.type == IFee_1.FeeTypeEnum.Percent) {
                return acc + getFeeAmtRangeBased(fee, totalTicketAndUpgrades);
            }
            return acc;
        }, 0);
        let promoterFeePercentPerOrder1 = Math.round(promoterFeePercentPerOrder);
        const ticketGuestFeeTotalForPromoter = tickets.reduce((cur, ticket) => {
            return (cur +
                guestFees.reduce((cur, fee) => {
                    const value = fee.appliedBy == IFee_1.FeeAppliedByEnum.Organization
                        ? cur + applyGuestTicketFee(ticket, fee)
                        : 0;
                    return value;
                }, 0));
        }, 0);
        const ticketGuestFeeTotalForSellout = tickets.reduce((cur, ticket) => {
            return (cur +
                guestFees.reduce((cur, fee) => {
                    const value = fee.appliedBy == IFee_1.FeeAppliedByEnum.Sellout
                        ? cur + applyGuestTicketFee(ticket, fee)
                        : 0;
                    return value;
                }, 0));
        }, 0);
        const orderSubtotal = Math.round(totalTicketAndUpgrades +
            promoterFeeFlatPerTicketTotal +
            promoterFeeFlatPerOrderTotal +
            promoterFeePercentPerTicketTotal1 +
            promoterFeePercentPerOrder1 +
            ticketGuestFeeTotalForPromoter +
            promoterFeeFlatPerUpgradeTotal);
        const salesTaxAmount = salesTaxFees
            ? (orderSubtotal * salesTaxFees.value) / 100
            : 0;
        const promoterTotal = Math.round(orderSubtotal) + Math.round(salesTaxAmount);
        // apply sellout percent fees on ticket and add-on total rather than promoter total
        const selloutPercentFeesAmt = selloutFees.reduce((acc, fee) => {
            if (fee.type == IFee_1.FeeTypeEnum.Percent && fee.appliedTo == IFee_1.FeeAppliedToEnum.Order) {
                // return acc + getFeeAmount(fee, promoterTotal);
                return acc + getFeeAmtRangeBased(fee, totalTicketAndUpgrades);
            }
            return acc;
        }, 0);
        const selloutFeeFlatPerTicketAmt = tickets.reduce((cur, ticket) => {
            return (cur +
                selloutFees.reduce((cur, fee) => {
                    var _a;
                    if (fee.type == IFee_1.FeeTypeEnum.Flat &&
                        fee.appliedTo === IFee_1.FeeAppliedToEnum.Ticket &&
                        !((_a = fee === null || fee === void 0 ? void 0 : fee.filters) === null || _a === void 0 ? void 0 : _a.includes(IFee_1.FeeFiltersEnum.Seated))) {
                        const value = cur + applyTicketFee(ticket, fee);
                        return value;
                    }
                    return cur;
                }, 0));
        }, 0);
        const selloutFeeFlatPerOrderAmt = selloutFees.reduce((cur, fee) => {
            if (fee.type === IFee_1.FeeTypeEnum.Flat &&
                fee.appliedTo === IFee_1.FeeAppliedToEnum.Order) {
                const value = cur + getFeeAmtRangeBased(fee, totalTicketAndUpgrades);
                return value;
            }
            return cur;
        }, 0);
        const selloutSeatedFeeAmt = tickets.reduce((cur, ticket) => {
            return (cur +
                selloutFees.reduce((cur, fee) => {
                    var _a;
                    if (fee.type == IFee_1.FeeTypeEnum.Flat &&
                        fee.appliedTo === IFee_1.FeeAppliedToEnum.Ticket &&
                        ((_a = fee === null || fee === void 0 ? void 0 : fee.filters) === null || _a === void 0 ? void 0 : _a.includes(IFee_1.FeeFiltersEnum.Seated))) {
                        const value = cur + applyTicketFee(ticket, fee);
                        return value;
                    }
                    return cur;
                }, 0));
        }, 0);
        const selloutFeesTotal = Math.round(selloutFeePercentPerTicketTotal +
            selloutFeePercentPerUpgradeTotal + // calculated total upgrade fees for sellout fees 
            selloutPercentFeesAmt +
            selloutFeeFlatPerTicketAmt +
            selloutFeeFlatPerOrderAmt +
            selloutSeatedFeeAmt +
            ticketGuestFeeTotalForSellout +
            SelloutFeeFlatPerUpgradeTotal);
        const preStripeTotal = promoterTotal + selloutFeesTotal;
        let stripeFeeAmt = 0;
        const stripeFeePercentage = ((_a = stripeFees.find((fee) => fee.type == IFee_1.FeeTypeEnum.Percent)) === null || _a === void 0 ? void 0 : _a.value) || 0;
        const stripeFeeFlat = ((_b = stripeFees.find((fee) => fee.type == IFee_1.FeeTypeEnum.Flat)) === null || _b === void 0 ? void 0 : _b.value) || 0;
        stripeFeeAmt =
            (preStripeTotal + stripeFeeFlat) / (1 - stripeFeePercentage / 100) -
                preStripeTotal;
        function applyTicketFee(ticket, fee) {
            // Ignore seated fees if not seated
            if (fee.filters &&
                fee.filters.includes(IFee_1.FeeFiltersEnum.Seated) &&
                !ticket.seat) {
                return 0;
            }
            const minFee = fee.minAppliedToPrice || 0;
            const maxFee = fee.maxAppliedToPrice || Infinity;
            if (minFee <= ticket.price && ticket.price <= maxFee) {
                if (fee.type === IFee_1.FeeTypeEnum.Flat) {
                    return fee.value;
                }
                if (fee.type === IFee_1.FeeTypeEnum.Percent) {
                    return (ticket.price * fee.value) / 100;
                }
            }
            else {
                return 0;
            }
            return 0;
        }
        function applyTicketDiscount(ticket, promotion) {
            if (promotion.ticketTypeIds.includes(ticket === null || ticket === void 0 ? void 0 : ticket.ticketTypeId) ||
                promotion.ticketTypeIds.length == 0) {
                if ((promotion === null || promotion === void 0 ? void 0 : promotion.discountType) === IEventPromotion_1.EventPromotionDiscountTypeEnum.Flat) {
                    return promotion.discountValue;
                }
                if (promotion.discountType === IEventPromotion_1.EventPromotionDiscountTypeEnum.Percent) {
                    return (ticket.origionalPrice * promotion.discountValue) / 100;
                }
            }
            else {
                return 0;
            }
        }
        function applyUpgradeFee(upgrade, fee) {
            const minFee = fee.minAppliedToPrice || 0;
            const maxFee = fee.maxAppliedToPrice || Infinity;
            if (minFee <= upgrade.price && upgrade.price <= maxFee) {
                if (fee.type === IFee_1.FeeTypeEnum.Flat) {
                    return fee.value;
                }
                if (fee.type === IFee_1.FeeTypeEnum.Percent) {
                    return (upgrade.price * fee.value) / 100;
                }
            }
            else {
                return 0;
            }
            return 0;
        }
        let promoterFeeAmount = promoterFeeFlatPerTicketTotal +
            promoterFeeFlatPerOrderTotal +
            promoterFeePercentPerTicketTotal1 +
            promoterFeePercentPerOrder1 +
            ticketGuestFeeTotalForPromoter +
            promoterFeeFlatPerUpgradeTotal;
        // calculate fee based on min and max 
        function getFeeAmtRangeBased(fee, amt = 0) {
            const minFee = fee.minAppliedToPrice || 0;
            const maxFee = fee.maxAppliedToPrice || Infinity;
            if (amt < minFee || amt > maxFee) {
                return 0;
            }
            if (fee.type === IFee_1.FeeTypeEnum.Flat) {
                return fee.value;
            }
            if (fee.type === IFee_1.FeeTypeEnum.Percent) {
                return amt * (fee.value / 100);
            }
            return 0;
        }
        let total = {
            salesTax: Math.round(salesTaxAmount || 0),
            total: Math.round(preStripeTotal) + Math.round(stripeFeeAmt) || 0,
            promoterFees: Math.round((promoterFeeAmount) || 0),
            stripeFees: Math.round(stripeFeeAmt || 0),
            selloutFees: Math.round(selloutFeesTotal || 0),
            orderSubtotal: Math.round(orderSubtotal || 0),
            subTotal: Math.round(totalTicketAndUpgrades || 0),
            totalFees: Math.round((promoterFeeAmount + stripeFeeAmt + selloutFeesTotal + salesTaxAmount) || 0),
            totalWithoutTaxFees: Math.round((promoterFeeAmount + stripeFeeAmt + selloutFeesTotal) || 0),
            guestFeeForPromoter: Math.round(ticketGuestFeeTotalForPromoter || 0),
            guestFeeForSellout: Math.round(ticketGuestFeeTotalForSellout || 0),
            discountAmount: Math.round(discount || discountOrder) || 0,
        };
        return total;
    }
    calculatePaymentSubtotal(params) {
        let { tickets = [], upgrades = [], paymentMethodType, } = params;
        if (paymentMethodType === PaymentMethodTypeEnum_1.PaymentMethodTypeEnum.None)
            return 0;
        const ticketTotal = tickets.reduce((cur, ticket) => cur + ticket.price, 0); // +  (ticket.price * tax/100)
        const upgradeTotal = upgrades.reduce((cur, upgrade) => cur + upgrade.price, 0);
        return ticketTotal + upgradeTotal;
    }
    calculatePaymentSubtotalValue(params) {
        let { tickets = [], upgrades = [], } = params;
        const ticketTotal = tickets.reduce((cur, ticket) => cur + ticket.price, 0); // +  (ticket.price * tax/100)
        const upgradeTotal = upgrades.reduce((cur, upgrade) => cur + upgrade.price, 0); // +  (upgrade.price * tax/100)
        return ticketTotal + upgradeTotal;
    }
    calculateFee(params) {
        let { fees } = params;
        const salesTax = fees.filter((f) => f.name == "Sales tax");
        const tax = salesTax.length > 0 ? salesTax[0].value : 0;
        const total = this.calculatePaymentTotal(params).total;
        let subtotal = this.calculatePaymentSubtotal(params);
        subtotal = subtotal + (subtotal * tax) / 100;
        return Math.round(total - subtotal);
    }
    calculateFeeWithoutTax(params) {
        const total = this.calculatePaymentTotal(params);
        return total;
    }
    calculateOrganizationFee(params) {
        let { tickets = [], upgrades = [], fees = [], paymentMethodType } = params;
        fees = FeeUtil_1.default.promoterFees(fees);
        return this.calculateFee({
            tickets,
            upgrades,
            fees,
            paymentMethodType,
        });
    }
    calculateTaxFee(params) {
        let { tickets = [], upgrades = [], fees = [], paymentMethodType } = params;
        fees = FeeUtil_1.default.taxFees(fees);
        return this.calculateFeeWithoutTax({
            tickets,
            upgrades,
            fees,
            paymentMethodType,
        });
    }
    calculatePlatformFee(params) {
        let { tickets = [], upgrades = [], fees = [], paymentMethodType } = params;
        fees = FeeUtil_1.default.selloutFees(fees);
        return this.calculateFee({
            tickets,
            upgrades,
            fees,
            paymentMethodType,
        });
    }
    calculateStripeFee(params) {
        const total = this.calculatePaymentTotal(params).total;
        const subtotal = this.calculatePaymentSubtotal(params);
        const platformFees = this.calculatePlatformFee(params);
        const organizationFee = this.calculateOrganizationFee(params);
        return total - subtotal - platformFees - organizationFee;
    }
    calculateProcessingFee(params) {
        const total = this.calculatePaymentTotal(params).total;
        const subtotal = this.calculatePaymentSubtotal(params);
        const organizationFee = this.calculateOrganizationFee(params);
        return total - subtotal - organizationFee;
    }
    calculateGuestFee(tickets, event) {
        var _a, _b;
        let guestTicketFees = event === null || event === void 0 ? void 0 : event.fees.filter((fee) => fee.filters && fee.filters[0] === IFee_1.FeeFiltersEnum.GuestTicket);
        let stripeFees = event === null || event === void 0 ? void 0 : event.fees.filter((fee) => fee.appliedBy === IFee_1.FeeAppliedByEnum.Stripe &&
            fee.type === IFee_1.FeeTypeEnum.Percent);
        let guestFeesValue = guestTicketFees && ((_a = guestTicketFees[0]) === null || _a === void 0 ? void 0 : _a.value);
        let stripeFeesValue = stripeFees && ((_b = stripeFees[0]) === null || _b === void 0 ? void 0 : _b.value);
        let guestMembers = tickets.filter((a) => a.guestTicket).length;
        let guestFees = guestFeesValue * guestMembers;
        return guestTicketFees.length > 0 && event.organization.isTegIntegration
            ? guestFees + (guestFees * stripeFeesValue) / 100
            : 0;
    }
}
exports.default = new PaymentUtil();
//# sourceMappingURL=PaymentUtil.js.map